function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { getLatestAppVersion } from '@ui/utils';
export function getGraphData(applications, param) {
    let { organization, project, application } = param;
    const nodes = [];
    let links = [];
    const nodeIds = {};
    applications.forEach((param)=>{
        let { id: applicationId, name, versions } = param;
        var _ref, _ref1;
        const applicationIndex = nodes.length;
        nodes.push({
            id: applicationIndex.toString(),
            fullName: name,
            label: name,
            size: 22,
            applicationId: name,
            organization,
            project,
            application
        });
        nodeIds[applicationId] = applicationIndex;
        const version = getLatestAppVersion(versions !== null && versions !== void 0 ? versions : []);
        ((_ref = version === null || version === void 0 ? void 0 : version.modules) !== null && _ref !== void 0 ? _ref : []).forEach((param)=>{
            let { name: moduleName } = param;
            const moduleIndex = nodes.length;
            nodes.push({
                id: moduleIndex.toString(),
                fullName: "".concat(name, "/").concat(moduleName),
                label: moduleName,
                size: 13,
                small: true,
                applicationId: name,
                organization,
                project,
                application
            });
            const nodeId = "".concat(name, ":").concat(moduleName);
            nodeIds[nodeId] = moduleIndex;
            links.push({
                source: applicationId,
                target: nodeId
            });
        });
        ((_ref1 = version === null || version === void 0 ? void 0 : version.consumes) !== null && _ref1 !== void 0 ? _ref1 : []).forEach((param)=>{
            let { applicationID, name } = param;
            links.push({
                source: applicationId,
                target: "".concat(applicationID, ":").concat(name)
            });
        });
    });
    const validLinks = [];
    links.forEach((link)=>{
        const sourceId = nodeIds[link.source];
        const targetId = nodeIds[link.target];
        if (sourceId !== undefined && targetId !== undefined) {
            validLinks.push(_object_spread_props(_object_spread({}, link), {
                source: sourceId.toString(),
                target: targetId.toString()
            }));
        }
    });
    links = validLinks;
    return {
        nodes,
        links
    };
}
